import { createContext, useContext } from 'react'

export const StaffBrandContext = createContext(null)

export const StaffBrandReportContext = createContext(null)

export const useStaffBrandContext = () => useContext(StaffBrandContext)

export const useReportStaffBrand = () => useContext(StaffBrandReportContext)
